const languageButtons = document.querySelectorAll('.navbar-language-button');
const languageNavigator = document.querySelector('#language-navigator');
const languageNavigatorClose = document.querySelector('.js-lang-navigator-close');

const openLanguageNavigator = () => {
  if (languageNavigator) {
    languageNavigator.classList.add('is-active');
    document.documentElement.classList.add('is-fixed');

    // Update ARIA states
    languageButtons.forEach((btn) => {
      btn.setAttribute('aria-expanded', 'true');
    });
  }
};

const closeLanguageNavigator = () => {
  if (languageNavigator) {
    languageNavigator.classList.remove('is-active');
    document.documentElement.classList.remove('is-fixed');

    // Update ARIA states
    languageButtons.forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
  }
};

languageButtons.forEach((languageButton) => {
  languageButton.addEventListener('click', function (e) {
    openLanguageNavigator();

    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'event',
        'eventCategory': 'Sales Portal',
        'eventAction': 'Language Selector',
        'eventLabel': 'Language Selector ' + e.target.dataset.locale,
        'eventNonInteraction': false
      });
    }
  });
});

if (languageNavigatorClose) {
  languageNavigatorClose.addEventListener('click', closeLanguageNavigator);
}

// Close on overlay click
if (languageNavigator) {
  languageNavigator.addEventListener('click', function(e) {
    if (e.target === languageNavigator) {
      closeLanguageNavigator();
    }
  });

  // Close on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && languageNavigator.classList.contains('is-active')) {
      closeLanguageNavigator();
    }
  });
}
